/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Anthropic_AuthInputs */



/**
* | output |
* | --- |
* | "The server answered like Anthropic's API, so it was asked again with an Anthropic key header." |
*
* @param {Private_Models_Hint_Anthropic_AuthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_anthropic_auth = /** @type {((inputs?: Private_Models_Hint_Anthropic_AuthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Anthropic_AuthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server antwortete wie die API von Anthropic und wurde daher erneut mit dem Schlüssel-Header von Anthropic gefragt.")
	return /** @type {LocalizedString} */ ("The server answered like Anthropic's API, so it was asked again with an Anthropic key header.")
});